
// taskTimelineSlice.ts
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';

interface TimelineEvent {
  when: string;
  type: string;
  taskId: string;
  actorId: string;
  title?: string;
  description?: string;
  sourceType: string;
  sourceId: string;
  hours?: number;
  approved?: boolean;
}

export const getTaskTimelineByTaskId = createAsyncThunk(
  'TaskTimeline/getByTaskId',
  async (taskId: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`Task/GetTaskTimeline?taskId=${taskId}`);
      if (data?.succeeded) return data.data;
      return [];
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  timelineList: TimelineEvent[];
  loading: boolean;
  error: string | null;
} = {
  timelineList: [],
  loading: false,
  error: null
};

const TaskTimelineSlice = createSlice({
  name: 'TaskTimeline',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getTaskTimelineByTaskId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTaskTimelineByTaskId.fulfilled, (state, action) => {
        state.loading = false;
        state.timelineList = action.payload;
      })
      .addCase(getTaskTimelineByTaskId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  }
});

export default TaskTimelineSlice.reducer;